/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Card } from '@blueprintjs/core';
import { FilterHub } from '/views/filterHub';
import { Filters } from '/views/filters';
import { Search } from '/views/search';
import { Screen } from '/views/screen';
import { ViewSettings } from '/views/viewSettings';
import { TimelineWrapper } from '/views/timeline/timelineWrapper';
import { ExplorerLayoutManager } from '../explorerLayoutManager';
import { explorerStyles } from './styles';
/**
 * NIH Document Data specific instance of a Workspace.
 *
 * @returns {null|*}
 * @constructor
 */

export function DocumentsExplorer({
	isReady,
	dilName,
	listComponent,
	searchField,
	widgetOutFilter,
	widgetInFilter,
	widgetOrder,
	showAllViews,
}) {
	return (
		<Screen
			isReady={isReady}
			dilName={dilName}
			widgetOutFilter={widgetOutFilter}
			widgetInFilter={widgetInFilter}
			widgetOrder={widgetOrder}
		>
			<div css={explorerStyles.container}>
				<div
					css={css`
						${explorerStyles.filters};
						padding: 0;
					`}
				>
					<span
						css={css`
							padding-left: 12px;
						`}
						className={'bp3-navbar-heading'}
					>
						Selection
					</span>
					<Filters />
				</div>

				<div css={explorerStyles.search}>
					<Search searchField={searchField} />
				</div>

				<Card css={explorerStyles.list}>
					<Card css={dataExplorer}>
						<ViewSettings showAllViews={showAllViews} />
					</Card>
					{listComponent}
				</Card>

				<Card css={explorerStyles.timeline}>
					<TimelineWrapper />
				</Card>

				<div css={panel}>
					<Card css={facets}>
						<FilterHub />
					</Card>
				</div>

				<div css={panel}>
					<Card css={facets}>
						<ExplorerLayoutManager />
					</Card>
				</div>
			</div>
		</Screen>
	);
}

const panel = css`
	grid-row: 3 span;
	display: flex;
	flex-direction: column;
`;

const dataExplorer = css`
	width: 100%;
	border-bottom: 1px solid lightgray;
	padding: 0;
	flex: 0;
	margin-bottom: 8px;
`;

const cards = css`
	display: flex;
	align-items: center;
`;

const tightCard = css`
	${cards};
	padding: 0;
	overflow: hidden;
`;

const list = css`
	padding: 0;
	overflow: hidden;
	display: flex;

	flex: 1;
`;

const facets = css`
	${tightCard};
	flex: 1;
`;
